import { render, staticRenderFns } from "./DataOwner.vue?vue&type=template&id=5421e178&scoped=true&"
import script from "./DataOwner.vue?vue&type=script&lang=js&"
export * from "./DataOwner.vue?vue&type=script&lang=js&"
import style0 from "./DataOwner.vue?vue&type=style&index=0&id=5421e178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5421e178",
  null
  
)

export default component.exports